import { combineReducers } from "redux";
import { overviewReducer, TemplatesListState } from "./overivew";
import { definitionReducer, TemplatesDefinitionState } from "./definition";

export type TemplatesState = Readonly<{
    overview: TemplatesListState;
    definition: TemplatesDefinitionState;
}>;

export const templatesReducers = combineReducers<TemplatesState>({
    overview: overviewReducer,
    definition: definitionReducer,
});
